var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup25(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "670px",
    height: "707px",
    viewBox: "0 0 670 707",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 25") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M293.374369,3.09329174 C216.696386,9.92235744 189.828673,57.6965299 212.771229,146.415809 C219.236815,263.267318 61.6280088,178.316018 12.1336781,268.49338 C-37.3606526,358.670741 78.8120232,388.4233 105.590475,421.718774 C132.368927,455.014249 12.1336781,482.556368 12.1336781,548.786844 C12.1336781,615.017319 67.9420858,685.796591 194.170775,653.193514 C320.399464,620.590437 305.099955,619.116332 371.481062,642.331476 C437.86217,665.546619 509.324568,764.776531 616.777904,659.508558 C688.413461,589.329909 710.209141,369.493723 682.164943,0 L293.374369,3.09329174 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "203.06363 28.7115223 357.034954 28.7115223 357.034954 136.931876 203.06363 136.931876"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-16.2%",
    y: "-21.3%",
    width: "132.5%",
    height: "146.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-4"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.10303442 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "93.3449659%",
    y2: "50%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2EAF4",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFDFD",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "0%",
    x2: "92.5269066%",
    y2: "0%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5EAF4",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "17.5722979%",
    y1: "50%",
    x2: "84.9371358%",
    y2: "50%",
    id: "linearGradient-7"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478FFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A2694",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-8"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3467D2",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A4E8E",
    offset: "93.4550383%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00188C",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-9"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478FFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A42B1",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "30.7833586%",
    y1: "22.0392331%",
    x2: "100%",
    y2: "80.5843869%",
    id: "linearGradient-10"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478FFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A2694",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-11"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E6FB0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#082883",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "36.9045275%",
    id: "linearGradient-12"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F5F6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8D8D8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "141.406226%",
    x2: "50%",
    y2: "0%",
    id: "linearGradient-13"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#071276",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F82BC",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "-7.97190797%",
    x2: "50%",
    y2: "63.2490079%",
    id: "linearGradient-14"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEEEEE",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8D8D8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "22.7723686%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-15"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEEEEE",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DADADA",
    offset: "76.6880072%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8D8D8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "-108.187826%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-16"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEEEEE",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8D8D8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "37.6729893%",
    x2: "88.2793801%",
    y2: "37.6729906%",
    id: "linearGradient-17"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8E02",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3BD00",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "96.2571747%",
    id: "linearGradient-18"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#192B9F",
    stopOpacity: 0.319010417,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8D8D8",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-50.5545317%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "linearGradient-19"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1047B03",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE9102",
    offset: "63.7125808%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3BD00",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "13.8658424%",
    y1: "30.3226924%",
    x2: "95.3254387%",
    y2: "65.0456191%",
    id: "linearGradient-20"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2885DA",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1896DA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "7.44103111%",
    y1: "39.3733443%",
    x2: "93.1369837%",
    y2: "24.6811931%",
    id: "linearGradient-21"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A84DA",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#149BDA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-22"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D9BFA",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D2E8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "75.851034%",
    y1: "10.251208%",
    x2: "10.5509052%",
    y2: "91.5471235%",
    id: "linearGradient-23"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06C3E8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#15B6EB",
    offset: "24.0029711%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#15B6EB",
    offset: "24.0029711%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#458EF6",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "11.4659665%",
    y1: "61.3241056%",
    x2: "58.7797511%",
    y2: "50%",
    id: "linearGradient-24"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#04CEE6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C93EC",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-25"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C5DEC",
    stopOpacity: 0.230666893,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8D8D8",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "2.30702977%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "linearGradient-26"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7EBF4",
    stopOpacity: 0.506255661,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8D8D8",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "14.7246262%",
    y1: "94.7014335%",
    x2: "80.6305279%",
    y2: "0%",
    id: "linearGradient-27"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F2EF",
    stopOpacity: 0.628708107,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8D8D8",
    stopOpacity: 0.414628623,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "100%",
    y2: "134.417778%",
    id: "linearGradient-28"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9EBF5",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0.474213089,
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Algorithm",
    transform: "translate(-666.000000, -104.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-25",
    transform: "translate(666.000000, 104.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#416CE1",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(116.049669, 164.391870)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-23",
    stroke: "none",
    fill: "#FBFBFB",
    fillRule: "evenodd",
    points: "176.286008 0 390.50698 0 390.50698 183.312027 176.286008 183.312027"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-25",
    stroke: "none",
    fill: "none"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-4)",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-29",
    stroke: "none",
    fill: "#D8D8D8",
    fillRule: "evenodd",
    points: "323.562927 39.7544155 348.10908 39.7544155 348.10908 50.7973087 323.562927 50.7973087"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-27",
    stroke: "none",
    fill: "url(#linearGradient-5)",
    fillRule: "evenodd",
    points: "216.452441 33.1286796 240.998594 33.1286796 240.998594 37.5458368 216.452441 37.5458368"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-27-Copy-4",
    stroke: "none",
    fill: "url(#linearGradient-5)",
    fillRule: "evenodd",
    points: "254.387404 33.1286796 278.933557 33.1286796 278.933557 37.5458368 254.387404 37.5458368"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.601447,68.4659378 L315.719515,68.4659378 C316.354094,68.4659378 316.868521,68.9803656 316.868521,69.6149444 L316.868521,129.157133 C316.868521,129.791712 316.354094,130.30614 315.719515,130.30614 L217.601447,130.30614 C216.966868,130.30614 216.452441,129.791712 216.452441,129.157133 L216.452441,69.6149444 C216.452441,68.9803656 216.966868,68.4659378 217.601447,68.4659378 Z",
    id: "Rectangle-28",
    stroke: "none",
    fill: "#F1F2F6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-27-Copy",
    stroke: "none",
    fill: "url(#linearGradient-6)",
    fillRule: "evenodd",
    points: "211.989504 44.1715728 276.702089 44.1715728 276.702089 48.58873 211.989504 48.58873"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-27-Copy-2",
    stroke: "none",
    fill: "url(#linearGradient-6)",
    fillRule: "evenodd",
    points: "211.989504 50.7973087 276.702089 50.7973087 276.702089 55.2144659 211.989504 55.2144659"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-27-Copy-3",
    stroke: "none",
    fill: "url(#linearGradient-6)",
    fillRule: "evenodd",
    points: "211.989504 57.4230446 276.702089 57.4230446 276.702089 61.8402019 211.989504 61.8402019"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.83883397,92.9274385 C8.06300082,96.944177 9.8221762,99.0531629 14.1163601,99.2543961 C18.410544,99.4556294 58.2526911,99.5562461 133.642801,99.5562461 C136.972701,97.2742968 138.661112,95.7854325 138.708034,95.0896531 C138.754956,94.3938737 138.754956,93.5311662 138.708034,92.5015304 L8.83883397,92.9274385 Z",
    id: "Path-19",
    stroke: "none",
    fill: "url(#linearGradient-7)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-20",
    stroke: "none",
    fill: "#0421AD",
    fillRule: "evenodd",
    points: "30.9289197 52.9646419 28.5044704 52.9646419 29.1456713 91.7807088 34.1899159 91.7807088 33.2136386 52.9646419"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-20-Copy",
    stroke: "none",
    fill: "#FFC911",
    fillRule: "evenodd",
    points: "36.8070057 41.9217488 32.9674073 41.9217488 33.9828767 91.7807088 39.0218527 91.7807088 39.0218527 41.9217488"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-20-Copy-2",
    stroke: "none",
    fill: "#EC1D4C",
    fillRule: "evenodd",
    points: "43.5014111 48.5474847 39.0485935 48.5474847 39.0485935 91.7807088 45.7162581 91.7807088 45.7162581 48.5474847"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-20-Copy-3",
    stroke: "none",
    fill: "url(#linearGradient-8)",
    fillRule: "evenodd",
    points: "48.2677066 66.2161138 45.324001 66.2161138 45.7307176 91.7807088 50.6950727 91.7807088 50.179195 66.2161138"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6338027,59.5242215 C50.2076111,60.6179184 48.615559,61.6261864 48.8576464,62.5490254 C49.0997339,63.4718645 51.5379777,73.1378954 56.1723779,91.5471182 L62.4585581,91.5471182 L53.6338027,59.5242215 Z",
    id: "Path-21",
    stroke: "none",
    fill: "#FE0033",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-22",
    stroke: "none",
    fill: "#FFC911",
    fillRule: "evenodd",
    points: "56.3964689 62.7450652 59.8836282 61.5682821 68.5081378 91.5836034 62.0606897 91.5836034 54.8981894 63.5899879"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-23",
    stroke: "none",
    fill: "#02D1E9",
    fillRule: "evenodd",
    points: "26.8588281 99.9334211 26.8588281 108.039943 31.3831815 108.039943 31.3831815 99.9334211"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-23-Copy",
    stroke: "none",
    fill: "#02D1E9",
    fillRule: "evenodd",
    points: "73.7196658 99.9334211 73.7196658 108.039943 78.2440191 108.039943 78.2440191 99.9334211"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-23-Copy-2",
    stroke: "none",
    fill: "#02D1E9",
    fillRule: "evenodd",
    points: "120.580503 99.9334211 120.580503 108.039943 125.104857 108.039943 125.104857 99.9334211"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-24",
    stroke: "none",
    fill: "#D8D8D8",
    fillRule: "evenodd",
    points: "185.211882 8.83431455 243.230062 8.83431455 243.230062 13.2514718 185.211882 13.2514718"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.046204,192.146341 L233.155182,192.146341 C233.789761,192.146341 234.304188,192.660769 234.304188,193.295348 L234.304188,230.75175 C234.304188,231.386329 233.789761,231.900757 233.155182,231.900757 L164.046204,231.900757 C163.411625,231.900757 162.897198,231.386329 162.897198,230.75175 L162.897198,193.295348 C162.897198,192.660769 163.411625,192.146341 164.046204,192.146341 Z",
    id: "Rectangle-37",
    stroke: "none",
    fill: "#051E85",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.509141,196.563499 L228.692245,196.563499 C229.326824,196.563499 229.841251,197.077927 229.841251,197.712505 L229.841251,226.334593 C229.841251,226.969172 229.326824,227.4836 228.692245,227.4836 L168.509141,227.4836 C167.874562,227.4836 167.360134,226.969172 167.360134,226.334593 L167.360134,197.712505 C167.360134,197.077927 167.874562,196.563499 168.509141,196.563499 Z",
    id: "Rectangle-37-Copy",
    stroke: "none",
    fill: "#01C8E7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-24",
    stroke: "none",
    fill: "#D8D8D8",
    fillRule: "evenodd",
    points: "347.701832 9.72943392 347.701832 13.1786969 377.420747 13.1786969 377.420747 9.72943392"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-30",
    stroke: "none",
    fill: "#FAD054",
    fillRule: "evenodd",
    points: "84.9861407 219.479518 84.9861407 230.113767 104.698431 230.113767 104.698431 221.640535 111.459758 210.747857 111.459758 189.378164 85.7067992 190.476626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.891173,229.591549 C84.891173,202.43317 84.891173,188.853981 84.891173,188.853981 C84.891173,188.853981 94.5517289,188.503913 113.872841,187.803777 L113.872841,192.583518 C99.5639934,198.87457 92.6308081,203.133024 93.0732851,205.358879 C93.515762,207.584735 95.057009,208.697663 97.6970262,208.697663 C98.0668055,210.213266 98.8456914,211.086507 100.033684,211.317387 C101.221676,211.548267 105.408024,211.639994 112.592728,211.592567 C111.662408,215.467466 110.726717,217.874551 109.785655,218.813822 C107.368791,221.226089 103.521095,220.672536 101.371868,220.627945 C97.9673653,220.55731 97.3040781,218.761198 99.3820069,215.239611 C95.1761923,214.833882 93.0732851,215.195534 93.0732851,216.324567 C93.0732851,217.4536 93.0732851,218.283352 93.0732851,218.813822 L85.8883772,218.601022",
    id: "Path-29",
    stroke: "none",
    fill: "#FE183F",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.650811,215.441042 C130.57549,214.482162 132.491077,214.482162 133.397572,215.441042 C134.757315,216.879364 134.213842,219.542533 132.752303,221.099406",
    id: "Path-90",
    stroke: "url(#linearGradient-9)",
    strokeWidth: 2.29801325,
    fill: "none",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-89",
    stroke: "none",
    fill: "url(#linearGradient-10)",
    fillRule: "evenodd",
    points: "112.331343 220.876196 123.2183 234.036484 135.248874 227.45634 123.790109 211.94609"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.412672,230.099026 C77.2272513,239.805951 72.7836058,247.327247 73.0817355,252.662914 C73.52893,260.666414 79.5934209,263.991282 77.3201281,295.773444 C76.083159,300.817289 81.227544,303.237871 95.1244856,301.551585 C109.021427,299.865298 118.170448,295.301884 118.688955,286.740791 C119.034626,281.033396 119.743665,269.674104 120.816073,252.662914 C113.067893,237.620322 107.897996,230.099026 105.306383,230.099026 C102.714769,230.099026 96.4168656,230.099026 86.412672,230.099026 Z",
    id: "Path-31",
    stroke: "none",
    fill: "#5776E2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.508774,252.701831 L103.390942,263.276777 C94.3570683,253.695905 89.9598751,247.268318 90.1993626,243.994016 C90.5585939,239.082562 95.8153681,234.121974 97.8907734,234.167014 C99.9661787,234.212055 103.05553,233.135861 104.84943,235.174964 C106.045363,236.534366 110.931811,242.376655 119.508774,252.701831 Z",
    id: "Path-32",
    stroke: "none",
    fill: "#4668D6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.2392579,322.538926 L128.319406,324.097282 L115.622433,337.453656 L115.622433,340.58388 L75.2908698,340.58388 C72.0831442,340.964461 70.451756,339.921053 70.3967054,337.453656 C70.3416548,334.986258 70.3141295,330.014682 70.3141295,322.538926 L72.2392579,322.538926 Z",
    id: "Path-42",
    stroke: "none",
    fill: "url(#linearGradient-11)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.9806778,339.077913 C91.6147799,345.927623 94.9638098,349.186584 100.027767,348.854796 C105.091725,348.523007 108.546289,348.357113 110.391459,348.357113 L113.597683,339.077913 L89.9806778,339.077913 Z",
    id: "Path-43",
    stroke: "none",
    fill: "url(#linearGradient-11)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.758448,264.292917 C110.778052,273.018475 119.23711,277.191539 129.135621,276.812107 C143.983388,276.24296 141.378444,266.257635 139.665718,257.474069 C138.5239,251.618359 135.872529,238.967914 131.711606,219.522734 C126.793148,221.277491 125.134203,223.52792 126.73477,226.274021 C128.335338,229.020122 129.135621,229.695501 129.135621,228.300158 C129.591277,231.597645 128.790994,232.660745 126.73477,231.48946 C124.678547,230.318174 124.280262,231.211075 125.539916,234.168165 L127.249412,234.168165 L127.249412,260.532923 C123.165772,258.630457 120.496243,256.367291 119.240824,253.743424 C116.587882,255.773032 111.427089,259.289529 103.758448,264.292917 Z",
    id: "Path-33",
    stroke: "none",
    fill: "#FAD054",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.149644,389.938423 L108.149644,393.56469 L74.14147,391.751557 C66.6459612,398.036297 62.7686805,401.58918 62.5096281,402.410205 C62.1210494,403.641742 51.6503038,404.308113 54.6127813,413.258775 C57.5752588,422.209437 62.8958869,422.219951 65.6356566,417.739363 C67.4621697,414.752304 68.3754263,411.381458 68.3754263,407.626824 C70.4438001,401.779759 73.0845885,398.914058 76.2977917,399.02972 C79.5109949,399.145382 90.1282791,399.679442 108.149644,400.631901 L108.149644,405.308855 C103.85324,407.621743 102.322124,410.271716 103.556296,413.258775 C105.350704,417.601767 107.425294,423.325111 114.756642,419.50741 C114.988916,419.386456 116.886813,417.876959 117.131279,417.739363 C122.438375,414.752304 121.646829,410.622311 114.756642,405.349384 L114.756642,400.631901 L149.673558,400.631901 L157.581276,406.710276 C155.902037,409.472651 155.482227,412.001426 156.321846,414.296601 C157.581276,417.739363 160.937673,422.219951 166.611607,417.739363 C172.285541,413.258775 170.113663,406.669883 167.915254,405.989369 C166.449648,405.535693 164.070726,404.342638 160.778488,402.410205 L152.073809,393.56469 L117.759173,393.56469 L117.759173,389.938423 L108.149644,389.938423 Z",
    id: "Path-45",
    stroke: "none",
    fill: "url(#linearGradient-12)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-44",
    stroke: "none",
    fill: "url(#linearGradient-11)",
    fillRule: "evenodd",
    points: "106.925968 369.714242 106.925968 391.238336 119.65513 391.238336 119.65513 349.426447 108.327553 352.439196"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.795426,336.03523 L97.3166244,374.789027 C97.9888778,378.078968 100.214674,379.695562 103.994013,379.63881 C107.773352,379.582058 118.604505,368.900548 136.487472,347.594283 L134.803843,332.380422 L114.795426,336.03523 Z",
    id: "Path-35",
    stroke: "none",
    fill: "#DEDFDD",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.9985516,300.493655 C82.0796067,318.089773 92.2536866,329.161339 108.520791,333.708353 C132.921448,340.528874 138.912102,342.643332 137.597976,351.350639 C136.283849,360.057945 130.413107,364.374056 131.683184,380.198585 C135.739356,386.462033 141.079064,384.679397 147.041575,377.534319 C153.004087,370.389242 165.624104,343.190718 160.091069,332.434349 C156.40238,325.263436 141.845842,313.194311 116.421455,296.226973 C101.102218,302.296655 89.6776402,304.030447 82.1477213,301.428347 C80.5804561,301.169933 79.1973995,300.858369 77.9985516,300.493655 Z",
    id: "Path-34",
    stroke: "none",
    fill: "#F7F5F6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.441162,381.93376 L131.441162,386.20294 C134.54982,388.058872 137.049184,388.967125 138.939255,388.9277 C140.829326,388.888275 141.453388,388.491609 140.811441,387.737704 L140.811441,383.893753 L131.441162,381.93376 Z",
    id: "Path-36",
    stroke: "none",
    fill: "#FAD054",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.692135,385.552425 C128.738564,388.704291 128.420707,390.95957 128.738564,392.318262 C129.056421,393.676954 135.164262,395.785931 147.062088,398.645193 C147.17373,394.280937 146.733662,392.098809 145.741883,392.098809 C145.047018,392.098809 143.028822,392.333256 141.256522,391.563552 C140.751658,391.344291 140.157539,390.7387 139.474165,389.746777 L129.692135,385.552425 Z",
    id: "Path-37",
    stroke: "none",
    fill: "#00015B",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-38",
    stroke: "none",
    fill: "#FAD054",
    fillRule: "evenodd",
    points: "102.480804 380.626161 99.5266986 384.201741 94.152264 380.626161 96.6463978 376.439807"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.4442119,381.276524 L88.8840135,384.749365 L102.305577,398.525267 C106.021859,397.390746 107.301622,396.218522 106.144867,395.008597 C104.988112,393.798671 102.856813,390.541989 99.7509706,385.238551 L93.4442119,381.276524 Z",
    id: "Path-39",
    stroke: "none",
    fill: "#00015B",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5343151,228.102803 L60.63261,297.226624 C68.2436914,302.878582 73.5813959,302.878582 76.6457236,297.226624 C81.242215,288.748687 72.4769276,267.553694 72.0492321,252.768822 C71.7641018,242.91224 71.6215366,234.185248 71.6215366,226.587845 C66.3611154,225.577873 62.6981399,225.577873 60.63261,226.587845 C58.5670801,227.597817 57.5343151,228.102803 57.5343151,228.102803 Z",
    id: "Path-40",
    stroke: "none",
    fill: "url(#linearGradient-13)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6547153,251.529689 L55.2262933,251.529689 L55.2262933,324.064338 L69.129287,336.47716 L69.129287,324.064338 C63.9462555,323.141185 61.1124794,318.623846 60.6279587,310.512321 C60.143438,302.400795 59.1523568,282.739918 57.6547153,251.529689 Z",
    id: "Path-41",
    stroke: "none",
    fill: "#F7F5F6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.147228,420.858524 L223.147228,423.965103 L189.792479,422.411813 C182.440988,427.795874 178.638204,430.839585 178.384129,431.542947 C178.003017,432.59799 167.733454,433.168862 170.639011,440.836785 C173.544568,448.504708 178.762967,448.513716 181.450095,444.67525 C183.241514,442.116273 184.137223,439.22851 184.137223,436.011961 C186.165856,431.002852 188.755905,428.547841 191.90737,428.646927 C195.058835,428.746013 205.472121,429.203536 223.147228,430.019496 L223.147228,434.026186 C218.933373,436.007608 217.431676,438.277808 218.642135,440.836785 C220.402065,444.557374 222.436795,449.460493 229.62728,446.189914 C229.855091,446.086295 231.716522,444.793127 231.956291,444.67525 C237.161417,442.116273 236.38508,438.578159 229.62728,434.060906 L229.62728,430.019496 L263.873309,430.019496 L271.629089,435.226766 C269.982115,437.593259 269.570371,439.75963 270.393858,441.725878 C271.629089,444.67525 274.920997,448.513716 280.485914,444.67525 C286.05083,440.836785 283.920682,435.192162 281.764513,434.609174 C280.327067,434.220515 277.993853,433.19844 274.764871,431.542947 L266.227442,423.965103 L232.572121,423.965103 L232.572121,420.858524 L223.147228,420.858524 Z",
    id: "Path-45-Copy",
    stroke: "none",
    fill: "url(#linearGradient-14)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.794777,392.147002 L325.794777,395.25358 L292.440029,393.700291 C285.088537,399.084351 281.285754,402.128063 281.031679,402.831425 C280.650566,403.886468 270.381003,404.45734 273.28656,412.125263 C276.192117,419.793186 281.410516,419.802193 284.097644,415.963728 C285.889063,413.404751 286.784772,410.516988 286.784772,407.300439 C288.813405,402.29133 291.403454,399.836318 294.554919,399.935405 C297.706384,400.034491 308.11967,400.492014 325.794777,401.307974 L325.794777,405.314664 C321.580923,407.296086 320.079225,409.566286 321.289684,412.125263 C323.049614,415.845851 325.084344,420.748971 332.274829,417.478392 C332.50264,417.374772 334.364071,416.081605 334.60384,415.963728 C339.808966,413.404751 339.032629,409.866636 332.274829,405.349384 L332.274829,401.307974 L366.520858,401.307974 L374.276638,406.515244 C372.629664,408.881737 372.21792,411.048107 373.041408,413.014356 C374.276638,415.963728 377.568546,419.802193 383.133463,415.963728 C388.698379,412.125263 386.568231,406.48064 384.412062,405.897652 C382.974616,405.508993 380.641402,404.486917 377.412421,402.831425 L368.874991,395.25358 L335.21967,395.25358 L335.21967,392.147002 L325.794777,392.147002 Z",
    id: "Path-45-Copy-2",
    stroke: "none",
    fill: "url(#linearGradient-15)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.608758,392.147002 L468.608758,395.25358 L435.25401,393.700291 C427.902518,399.084351 424.099735,402.128063 423.84566,402.831425 C423.464547,403.886468 413.194985,404.45734 416.100542,412.125263 C419.006099,419.793186 424.224497,419.802193 426.911626,415.963728 C428.703044,413.404751 429.598754,410.516988 429.598754,407.300439 C431.627386,402.29133 434.217435,399.836318 437.368901,399.935405 C440.520366,400.034491 450.933652,400.492014 468.608758,401.307974 L468.608758,405.314664 C464.394904,407.296086 462.893207,409.566286 464.103666,412.125263 C465.863596,415.845851 467.898325,420.748971 475.08881,417.478392 C475.316621,417.374772 477.178053,416.081605 477.417822,415.963728 C482.622948,413.404751 481.846611,409.866636 475.08881,405.349384 L475.08881,401.307974 L509.33484,401.307974 L517.09062,406.515244 C515.443645,408.881737 515.031902,411.048107 515.855389,413.014356 C517.09062,415.963728 520.382528,419.802193 525.947444,415.963728 C531.512361,412.125263 529.382213,406.48064 527.226043,405.897652 C525.788597,405.508993 523.455384,404.486917 520.226402,402.831425 L511.688972,395.25358 L478.033651,395.25358 L478.033651,392.147002 L468.608758,392.147002 Z",
    id: "Path-45-Copy-3",
    stroke: "none",
    fill: "url(#linearGradient-16)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-9",
    stroke: "none",
    fill: "url(#linearGradient-17)",
    fillRule: "evenodd",
    cx: 538.899633,
    cy: 135.827586,
    rx: 27.8933557,
    ry: 27.607233
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-40",
    stroke: "none",
    fill: "url(#linearGradient-18)",
    fillRule: "evenodd",
    points: "511.006277 139.140454 566.792989 139.140454 566.792989 200.980656 511.006277 200.980656"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-9-Copy",
    stroke: "none",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    cx: 538.899633,
    cy: 135.827586,
    rx: 23.4304188,
    ry: 23.1900757
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-34",
    stroke: "none",
    fill: "#091B80",
    fillRule: "evenodd",
    points: "535.55243 112.637511 540.015367 112.637511 540.015367 119.263246 535.55243 119.263246"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-34-Copy",
    stroke: "none",
    fill: "#091B80",
    fillRule: "evenodd",
    points: "515.469214 134.723297 522.16362 134.723297 522.16362 139.140454 515.469214 139.140454"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-34-Copy-3",
    stroke: "none",
    fill: "#091B80",
    fillRule: "evenodd",
    points: "537.783899 152.391926 542.246836 152.391926 542.246836 159.017662 537.783899 159.017662"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-10",
    stroke: "none",
    fill: "url(#linearGradient-19)",
    fillRule: "evenodd",
    cx: 540.015367,
    cy: 136.931876,
    rx: 6.69440538,
    ry: 6.62573591
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-35",
    stroke: "none",
    fill: "#091B80",
    fillRule: "evenodd",
    points: "526.626557 134.723297 540.015367 134.723297 540.015367 139.140454 526.626557 139.140454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.36161,197.449726 L214.36161,222.748236 C214.755993,224.122087 215.434543,224.906969 216.397259,225.10288 C217.359975,225.298791 220.150651,226.514331 224.769287,228.749499 L224.769287,235.290259 L245.879306,235.290259 L242.440071,197.449726 L214.36161,197.449726 Z",
    id: "Path-47",
    stroke: "none",
    fill: "#FAD054",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.699895,194.186025 L242.224135,194.186025 C248.03342,195.770629 251.003544,200.64565 251.134505,208.811088 C251.265466,216.976526 251.330947,224.079541 251.330947,230.120135 L218.638347,230.120135 L218.638347,205.86871 C219.324645,203.881894 218.777306,201.991797 216.996332,200.198419 C215.215358,198.40504 213.449879,196.400909 211.699895,194.186025 Z",
    id: "Path-46",
    stroke: "none",
    fill: "#FE183F",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.306451,326.869638 L366.976744,326.869638 C368.880481,326.869638 370.423764,328.412922 370.423764,330.316658 L370.423764,341.091248 C370.423764,342.994984 368.880481,344.538267 366.976744,344.538267 L291.306451,344.538267 C289.402715,344.538267 287.859431,342.994984 287.859431,341.091248 L287.859431,330.316658 C287.859431,328.412922 289.402715,326.869638 291.306451,326.869638 Z",
    id: "Rectangle-32",
    stroke: "none",
    fill: "url(#linearGradient-11)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.793443,225.667189 C181.785712,232.356001 185.609698,235.700407 187.265399,235.700407 C187.265399,238.370971 187.265399,250.75164 187.265399,272.842414 C189.554978,279.269626 192.669234,282.407002 196.608166,282.25454 C200.547098,282.102078 202.982199,277.511353 203.913468,268.482367 L200.093159,244.050922 L191.990413,231.418245 C192.290144,228.642512 191.792431,226.360544 190.497275,224.57234 C188.554541,221.890036 186.685486,223.477492 187.265399,224.57234 C187.652008,225.30224 187.845312,226.298368 187.845312,227.560726 C185.780948,228.507578 184.216469,227.876399 183.151875,225.667189 C182.087281,223.457979 179.822929,223.09303 176.358821,224.57234 L175.793443,225.667189 Z",
    id: "Path-49",
    stroke: "none",
    fill: "#FAD054",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.287035,262.354196 C197.42111,247.362046 203.784982,238.519083 213.37865,235.825304 C222.752383,235.240539 236.068702,235.240539 253.327608,235.825304 C261.336244,238.786729 265.373552,243.406966 265.439532,249.686017 C265.505513,255.965068 265.538503,267.599766 265.538503,284.59011 L261.337493,284.59011 L261.337493,258.835958 L199.534736,259.98842 L199.534736,263.16975 L195.732609,263.16975 L194.287035,262.354196 Z",
    id: "Path-48",
    stroke: "none",
    fill: "#01C8E7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.750199,286.774877 L191.750199,344.323226 C191.472751,346.855537 192.708678,348.23325 195.45798,348.456363 C198.207281,348.679477 219.943261,348.791034 260.665921,348.791034 C264.930555,349.818574 267.115172,347.52903 267.219774,341.922403 C267.324376,336.315775 267.376678,317.933266 267.376678,286.774877 L260.665921,286.774877 L260.665921,259.181599 L199.696882,259.181599 L199.696882,286.774877 L191.750199,286.774877 Z",
    id: "Path-50",
    stroke: "none",
    fill: "url(#linearGradient-11)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-30",
    stroke: "none",
    fill: "#F7F5F6",
    fillRule: "evenodd",
    points: "214.220972 337.912532 245.461531 337.912532 245.461531 357.789739 214.220972 357.789739"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-31",
    stroke: "none",
    fill: "url(#linearGradient-11)",
    fillRule: "evenodd",
    x: 185.211882,
    y: 355.581161,
    width: 84.7958015,
    height: 19.8772077,
    rx: 3.44701987
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-52",
    stroke: "none",
    fill: "#F7F5F6",
    fillRule: "evenodd",
    points: "216.017764 385.477108 216.017764 399.190653 223.182792 399.190653 236.004846 405.028808 245.840798 403.953801 244.83708 378.755111 214.588961 376.801861"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-53",
    stroke: "none",
    fill: "#FAD054",
    fillRule: "evenodd",
    points: "218.545647 399.888129 218.545647 406.269386 236.664293 412.495472 245.278328 408.348214 245.278328 403.747438 236.664293 404.650476 224.573612 398.887508"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.271701,404.467135 C219.500036,403.333946 214.387908,407.367416 212.604329,407.367416 C211.415276,407.367416 209.919666,407.367416 208.117499,407.367416 L208.117499,412.911224 L221.271701,412.911224 C222.452811,408.03729 222.452811,405.222594 221.271701,404.467135 Z",
    id: "Path-54",
    stroke: "none",
    fill: "#FD1632",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.257152,406.171022 L246.98865,414.993546 L233.756582,418.634825 L231.422655,416.567195 L231.422655,411.631679 C233.787486,411.81318 235.818702,411.534082 237.516302,410.794383 C239.213901,410.054684 239.896711,409.151194 239.564732,408.083914 L245.257152,406.171022 Z",
    id: "Path-55",
    stroke: "none",
    fill: "#FD1632",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.860868,374.554521 C208.549877,381.21096 210.854215,384.494121 214.773883,384.404005 C218.693551,384.313889 221.614575,384.268831 223.536956,384.268831 L223.536956,400.245243 L220.394764,400.245243 L220.394764,419.68441 L234.88914,419.68441 L234.88914,400.245243 L231.634589,400.245243 L231.634589,384.268831 L240.705681,384.268831 C247.032038,382.404517 249.583373,379.166414 248.359688,374.554521 C243.257017,374.554521 229.75741,374.554521 207.860868,374.554521 Z",
    id: "Path-51",
    stroke: "none",
    fill: "url(#linearGradient-11)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.971495,232.005714 L298.971495,254.130737 L293.407719,254.130737 L293.407719,309.316099 C292.212237,315.065757 293.139533,318.133845 296.189607,318.520364 C299.239682,318.906882 321.467687,319.100141 362.873623,319.100141 C367.199676,319.137216 369.362702,316.292361 369.362702,310.565578 C369.362702,304.838796 369.362702,286.652316 369.362702,256.00614 L362.873623,256.00614 L362.873623,230.391803 L298.971495,230.391803 L298.971495,232.005714 Z",
    id: "Path-70",
    stroke: "none",
    fill: "url(#linearGradient-11)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.796122,251.47162 L314.917702,251.47162 C307.650282,258.627299 303.154437,264.043785 301.430168,267.721076 C298.843764,273.237014 297.320187,285.494652 297.714765,286.972684 C297.977817,287.958039 302.956468,287.958039 312.650718,286.972684 C308.807874,299.505169 308.807874,306.063569 312.650718,306.647882 C318.414985,307.524351 336.428755,307.558278 339.310888,307.558278 C341.232311,307.558278 344.480284,307.936721 349.054808,308.693608 L358.582676,308.693608 L358.582676,287.850771 L372.637161,287.850771 L370.515591,269.617129 C362.500406,258.094194 357.558517,252.332727 355.689923,252.332727 C353.821329,252.332727 350.072976,252.332727 344.444865,252.332727 L324.796122,251.47162 Z",
    id: "Path-59",
    stroke: "none",
    fill: "#03C7E7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.238653,265.874999 C309.418785,267.620111 312.508851,271.082769 312.508851,276.262975 C312.508851,281.443181 312.508851,284.463136 312.508851,285.322841 L314.067536,288.64563 L332.456089,288.64563 L332.456089,267.667992 L327.462693,266.882093 L327.462693,259.806536 L319.675834,259.806536 L326.15781,251.835722 L316.076003,251.835722 C309.49928,257.136005 305.715541,260.599643 304.724786,262.226634 C303.734031,263.853625 303.238653,265.069746 303.238653,265.874999 Z",
    id: "Path-60",
    stroke: "none",
    fill: "url(#linearGradient-20)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.639216,254.821023 C351.321006,253.304284 354.801531,253.659054 357.080791,255.885332 C359.360051,258.11161 361.820287,260.555746 364.461498,263.217739 C358.520738,265.966875 355.550357,270.409289 355.550357,276.544982 C355.550357,282.680675 355.550357,286.598353 355.550357,288.298017 L332.943802,288.298017 L332.943802,266.272063 L340.784911,265.622998 L340.784911,258.185794 L347.898187,258.185794 L346.639216,254.821023 Z",
    id: "Path-61",
    stroke: "none",
    fill: "url(#linearGradient-21)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-8",
    stroke: "none",
    fill: "#061B83",
    fillRule: "evenodd",
    cx: 339.183206,
    cy: 276.07233,
    rx: 2.23146846,
    ry: 2.20857864
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-8-Copy",
    stroke: "none",
    fill: "#061B83",
    fillRule: "evenodd",
    cx: 339.183206,
    cy: 282.698066,
    rx: 2.23146846,
    ry: 2.20857864
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-8-Copy-2",
    stroke: "none",
    fill: "#061B83",
    fillRule: "evenodd",
    cx: 339.183206,
    cy: 300.366695,
    rx: 2.23146846,
    ry: 2.20857864
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.249547,216.215112 L352.249547,237.060115 C348.213479,242.861304 345.106632,245.377241 342.929004,244.607928 C342.929004,246.741989 342.929004,249.211676 342.929004,252.016991 L336.087402,260.180456 L326.193852,252.016991 L326.193852,241.652491 L326.193852,217.003633 L352.249547,216.215112 Z",
    id: "Path-57",
    stroke: "none",
    fill: "#FAD054",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.145986,211.781198 L326.366213,211.781198 C320.487538,215.825906 317.5482,220.634872 317.5482,226.208097 C317.5482,231.781322 317.5482,236.557939 317.5482,240.537947 L331.716314,240.537947 C336.017436,236.875874 337.561028,234.577791 336.347093,233.643697 C334.526189,232.242556 335.353525,224.925234 336.347093,224.344458 C337.340661,223.763683 344.652619,222.806085 349.29642,218.250102 C352.392288,215.212781 354.342143,213.056479 355.145986,211.781198 Z",
    id: "Path-56",
    stroke: "none",
    fill: "#FE183F",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.793976,287.959375 C298.9166,296.882215 300.482834,302.509407 302.49268,304.840951 C304.502526,307.172495 308.250138,308.179281 313.735518,307.861308 L348.585204,308.814084 C347.115672,306.632018 346.049071,305.540985 345.385399,305.540985 C344.721727,305.540985 341.505206,305.30764 335.735834,304.840951 C327.708749,301.824397 323.471741,300.202205 323.02481,299.974376 C322.354413,299.632632 316.66728,297.209043 314.344813,292.029821 C312.796501,288.577006 311.857775,287.077096 311.528633,287.530093 L297.793976,287.959375 Z",
    id: "Path-62",
    stroke: "none",
    fill: "#FAD054",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-58",
    stroke: "none",
    fill: "#03C7E7",
    fillRule: "evenodd",
    points: "326.056536 250.945721 320.659889 258.493077 327.977725 258.493077 327.977725 267.044079 341.540928 267.044079 341.540928 259.478632 347.840481 258.9949 343.799857 249.306365 336.489245 259.478632"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.238419,288.940136 L379.06517,288.940136 C397.420954,278.548269 406.994439,272.619642 407.785626,271.154256 C408.972405,268.956178 411.452774,265.69743 411.329744,265.084286 C411.206715,264.471142 412.650234,263.549076 412.649839,266.706416 C412.649575,268.81131 412.873085,269.863756 413.320369,269.863756 C415.82632,268.30127 417.105404,266.708113 417.157622,265.084286 C417.23595,262.648545 422.220819,261.120775 421.952211,266.137516 C421.773139,269.482009 408.17423,281.979161 381.155484,303.628971 C370.718418,306.765691 364.615076,306.96968 362.845456,304.240941 C361.075836,301.512201 359.746511,299.548783 358.857482,298.350685 L358.857482,288.418219 L372.238419,288.940136 Z",
    id: "Path-63",
    stroke: "none",
    fill: "#FAD054",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.577129,394.811235 L325.577129,400.405873 C328.18737,401.712675 329.576796,402.886225 329.745407,403.926521 C329.914018,404.966817 330.979165,404.966817 332.940848,403.926521 L335.169584,394.811235 L325.577129,394.811235 Z",
    id: "Path-65",
    stroke: "none",
    fill: "#FAD054",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.830047,401.456341 L324.306924,409.642651 C332.490536,412.200831 336.706672,414.031474 336.955331,415.13458 C337.32832,416.789238 343.372782,415.872905 342.289071,412.757778 C341.566597,410.681027 338.591216,407.564214 333.362928,403.407341 L330.546056,404.611418 L325.830047,401.456341 Z",
    id: "Path-67",
    stroke: "none",
    fill: "url(#linearGradient-22)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-68",
    stroke: "none",
    fill: "#FAD054",
    fillRule: "evenodd",
    points: "341.801631 394.092302 341.801631 397.934123 348.702946 397.934123 348.702946 394.092302"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.712216,398.677 L341.712216,406.231183 L360.303408,406.231183 C357.51025,401.900347 354.995045,399.558608 352.757794,399.205965 C350.520542,398.853322 348.964889,398.677 348.090835,398.677 L341.712216,398.677 Z",
    id: "Path-69",
    stroke: "none",
    fill: "url(#linearGradient-22)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.043042,344.31026 C307.403089,350.252609 309.955192,353.296573 315.69935,353.442153 C321.443508,353.587732 324.111161,353.909722 323.702308,354.40812 L323.702308,369.432566 L321.393572,369.432566 L321.393572,390.270695 L336.364721,390.270695 L336.364721,343.363216 L308.043042,343.363216 L308.043042,344.31026 Z",
    id: "Path-71",
    stroke: "none",
    fill: "url(#linearGradient-11)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.075278,192.657351 L470.075278,213.377691 C471.580208,218.166804 473.996141,220.520495 477.323077,220.438764 C477.323077,222.686886 477.323077,225.68054 477.323077,229.419726 L495.581528,229.419726 L495.581528,220.438764 L496.643925,196.130912 L470.075278,192.657351 Z",
    id: "Path-73",
    stroke: "none",
    fill: "#FAD054",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.832963,188.993421 L492.384478,188.993421 C495.662863,190.971044 497.302055,192.383972 497.302055,193.232206 C497.302055,194.080439 497.302055,202.777927 497.302055,219.32467 C493.535571,219.750438 490.264775,218.598055 487.489669,215.86752 C484.714562,213.136986 483.722293,211.15435 484.512862,209.919613 C487.783868,207.715538 489.162063,205.858638 488.647448,204.348914 C488.132834,202.839189 484.789043,201.611954 478.616077,200.667208 C476.438517,198.881492 474.862648,197.462585 473.888469,196.410488 C472.914291,195.358391 470.895789,192.886035 467.832963,188.993421 Z",
    id: "Path-72",
    stroke: "none",
    fill: "#FE183F",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.940572,229.261781 C490.805306,227.898061 499.02806,230.13381 499.608835,235.969027 C500.479997,244.721854 509.271245,282.235145 504.44004,299.036196 C492.033806,299.036196 478.386791,298.070064 463.498995,296.1378 C464.307959,267.220497 465.985312,249.366267 468.531054,242.575112 C471.076796,235.783957 473.213302,231.34618 474.940572,229.261781 Z",
    id: "Path-74",
    stroke: "none",
    fill: "url(#linearGradient-23)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.495911,252.14076 L477.48156,263.492027 L490.257809,250.409251 C492.652217,243.627506 492.652217,239.214431 490.257809,237.170027 C486.666197,234.10342 478.698572,233.177674 472.703837,238.948588 C468.707347,242.795864 465.304705,247.193254 462.495911,252.14076 Z",
    id: "Path-75",
    stroke: "none",
    fill: "#55DBF0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-77",
    stroke: "none",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    points: "378.941936 209.136113 420.121673 253.743505 438.602658 237.606717 396.233328 193.809108"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.209004,252.486591 L455.458871,261.055916 C455.107871,262.949754 453.298992,262.949754 450.032234,261.055916 C446.765476,259.162077 440.605937,255.097579 431.553618,248.86242 L432.808661,243.839631 C431.397196,242.588882 430.350537,242.37394 429.668685,243.194804 C428.645906,244.426101 427.722638,241.763064 427.836457,240.170528 C427.950276,238.577992 421.343384,237.544937 420.283408,239.069819 C419.223431,240.594701 418.163454,243.556358 419.223431,244.869153 C419.930082,245.744351 426.555347,253.929627 439.099224,269.424984 C446.945406,276.741989 454.714314,279.134049 462.405947,276.601165 C470.09758,274.068281 475.174147,269.900628 477.635646,264.098206 L463.209004,252.486591 Z",
    id: "Path-76",
    stroke: "none",
    fill: "#FAD054",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.066304,342.362869 L411.571575,376.945961 C412.779797,378.15493 414.195585,378.759415 415.81894,378.759415 C418.253972,378.759415 419.231171,380.693108 421.496919,375.643033 C423.007418,372.276317 424.500213,367.775534 425.975306,362.140686 L434.04052,341.170326 L420.066304,342.362869 Z",
    id: "Path-79",
    stroke: "none",
    fill: "#DEDFDD",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.383952,296.276581 C434.648627,317.67489 420.280964,331.612886 420.280964,338.090572 C420.280964,347.807099 421.979885,365.343473 439.500101,382.168074 C441.367661,384.216631 449.014427,386.085805 449.482151,377.567378 C449.949875,369.048951 438.591532,349.445912 442.686325,344.700189 C446.781118,339.954466 497.470061,325.706233 501.374822,312.28428 C503.314731,305.764397 504.504799,301.43153 504.945025,299.285678 L463.383952,296.276581 Z",
    id: "Path-78",
    stroke: "none",
    fill: "#F7F5F6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-80",
    stroke: "none",
    fill: "#FAD054",
    fillRule: "evenodd",
    points: "441.653436 384.077087 441.653436 389.392157 450.369779 388.488692 449.516529 380.76017"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.511848,385.95183 C439.516552,390.374666 433.911061,393.69046 432.695375,395.899211 C433.098523,398.232917 436.235618,398.232917 442.106659,395.899211 C444.471076,393.464699 446.028772,392.649685 446.779745,393.454169 C447.530719,394.258653 447.906206,395.073667 447.906206,395.899211 L452.646105,395.062716 L449.511848,385.95183 Z",
    id: "Path-81",
    stroke: "none",
    fill: "#0E1977",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-82",
    stroke: "none",
    fill: "#FAD054",
    fillRule: "evenodd",
    points: "413.114399 379.217283 413.114399 384.283703 419.323371 384.283703 419.323371 379.217283"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.514756,384.536966 L401.584637,385.693981 C399.160735,387.936321 399.609181,389.415545 402.929974,390.131653 C406.250767,390.84776 410.278267,390.84776 415.012475,390.131653 L415.012475,392.462136 L419.354838,392.462136 L420.133185,384.536966 L412.514756,384.536966 Z",
    id: "Path-83",
    stroke: "none",
    fill: "#0E1977",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.166156,232.60709 C528.679518,227.785464 527.362012,225.192957 524.213637,224.829568 C519.491075,224.284485 515.169046,226.641135 515.113158,232.60709 C515.075899,236.584393 515.05727,245.155357 515.05727,258.319981 C510.268436,265.461167 508.238366,273.471576 508.967062,282.351208 C510.060105,295.670655 511.164645,298.338118 515.113158,299.529232 C519.061671,300.720346 525.557157,300.708662 525.557157,296.276865 C525.557157,293.322334 526.426823,272.099075 528.166156,232.60709 Z",
    id: "Path-84",
    stroke: "none",
    fill: "url(#linearGradient-11)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.5074,252.2807 L531.782386,252.2807 L531.782386,320.349951 C523.865743,330.697046 518.757179,335.755778 516.456695,335.526148 C516.456695,330.766164 516.456695,326.498287 516.456695,322.722517 C524.15287,320.830062 527.707771,315.86501 527.121395,307.827361 C526.53502,299.789712 526.997021,281.274159 528.5074,252.2807 Z",
    id: "Path-85",
    stroke: "none",
    fill: "#F7F5F6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.898849,322.471405 L455.713807,322.471405 L452.827671,340.717072 L507.084079,340.717072 C513.347078,340.43972 516.478577,338.55913 516.478577,335.075301 C516.478577,331.591472 516.478577,327.390173 516.478577,322.471405 L514.898849,322.471405 Z",
    id: "Path-86",
    stroke: "none",
    fill: "url(#linearGradient-11)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.916459,341.97703 C453.81932,348.383057 457.287058,351.58607 461.319673,351.58607 C465.352289,351.58607 468.059939,351.58607 469.442624,351.58607 L469.442624,368.808205 L477.283461,368.808205 L477.283461,351.58607 L486.036791,351.58607 C491.601256,348.378683 494.383488,345.726408 494.383488,343.629246 C494.383488,341.532083 494.383488,340.384391 494.383488,340.186167 L451.73538,340.186167 L450.916459,341.97703 Z",
    id: "Path-87",
    stroke: "none",
    fill: "url(#linearGradient-11)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-33",
    stroke: "none",
    fill: "url(#linearGradient-11)",
    fillRule: "evenodd",
    points: "466.376908 368.832632 481.997187 368.832632 481.997187 390.918419 466.376908 390.918419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.19583,288.020644 L451.796068,288.020644 C454.109949,289.17724 455.26267,292.094265 455.25423,296.771719 C448.173772,296.771719 334.062933,296.771719 112.921715,296.771719 L120.19583,288.020644 Z",
    id: "Path-88",
    stroke: "none",
    fill: "#E6EBE7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-36",
    stroke: "none",
    fill: "#F7F5F6",
    fillRule: "evenodd",
    points: "158.434261 298.158116 167.360134 298.158116 167.360134 428.464256 158.434261 428.464256"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-36-Copy",
    stroke: "none",
    fill: "#F7F5F6",
    fillRule: "evenodd",
    points: "403.895791 298.158116 412.821665 298.158116 412.821665 428.464256 403.895791 428.464256"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.950847,405.973238 L576.763039,405.973238 L576.763039,428.889563 C572.87549,437.789843 566.741198,442.239983 558.360163,442.239983 C549.979128,442.239983 535.457142,442.239983 514.794205,442.239983 C505.5653,438.661418 500.950847,434.211278 500.950847,428.889563 C500.950847,423.567849 500.950847,415.929073 500.950847,405.973238 Z",
    id: "Path-91",
    stroke: "none",
    fill: "#EDC033",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.58694,408.622562 C514.964555,424.85901 524.465911,433.744461 534.091006,435.278916 C543.716101,436.813371 555.113492,436.813371 568.283179,435.278916 C571.965503,433.043804 573.838736,429.545843 573.902878,424.785032 C573.96702,420.024222 573.934949,414.636732 573.806665,408.622562 L505.58694,408.622562 Z",
    id: "Path-92",
    stroke: "none",
    fill: "#FCA10A",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-38",
    stroke: "none",
    fill: "#141870",
    fillRule: "evenodd",
    points: "517.700683 443.924306 526.626557 443.924306 526.626557 448.341463 517.700683 448.341463"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-38-Copy",
    stroke: "none",
    fill: "#141870",
    fillRule: "evenodd",
    points: "548.941241 443.924306 557.867115 443.924306 557.867115 448.341463 548.941241 448.341463"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.614943,403.639947 C530.614943,398.583144 529.90957,392.901337 528.498825,386.594526",
    id: "Path-93",
    stroke: "#1937A7",
    strokeWidth: 2.29801325,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.511891,387.607674 C524.268075,395.429005 520.363275,397.764635 515.797493,394.614566 C511.23171,391.464496 509.446271,388.320571 510.441177,385.182789 C516.868364,387.039005 520.15776,386.805847 520.309364,384.483313 C520.536771,380.999512 512.771608,385.80999 509.551643,379.775671 C507.405,375.752792 506.331678,373.247062 506.331678,372.258481 C513.486175,376.49932 517.349806,377.150936 517.922571,374.213329 C518.781719,369.806918 507.150637,374.354 507.081533,366.321662 C507.052682,362.968175 507.668894,363.761681 509.551643,364.178606 C510.300742,364.34449 511.868413,364.51087 514.254654,364.677747 C511.722465,360.632231 510.808916,356.64169 511.514008,352.706124 C512.571647,346.802775 515.535779,360.413948 517.922571,361.4457 C520.309364,362.477452 522.586865,365.331626 522.157046,357.944436 C521.727227,350.557247 529.376236,362.36637 522.586865,367.005616 C515.797493,371.644863 528.622461,374.902134 528.745966,367.005616 C528.869472,359.109099 540.708356,370.042179 534.110124,375.452208 C529.711302,379.058893 527.018033,380.862236 526.030316,380.862236 C528.601386,385.665438 532.373859,384.766758 537.347732,378.166196 C544.808543,368.265353 540.648074,386.302825 535.697072,386.955249 C532.396403,387.390199 529.66801,387.607674 527.511891,387.607674 Z",
    id: "Path-94",
    stroke: "none",
    fill: "url(#linearGradient-24)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.331015,369.113383 C558.880886,377.706847 554.727735,380.273055 549.871561,376.812006 C545.015387,373.350956 543.116391,369.896658 544.174574,366.44911 C551.010541,368.488575 554.509148,368.232398 554.670395,365.680581 C554.912265,361.852854 546.653225,367.138229 543.228465,360.508193 C540.945292,356.088169 539.803705,353.33507 539.803705,352.248896 C547.41324,356.908397 551.522604,357.624341 552.131798,354.396729 C553.045589,349.55531 540.674751,354.551287 540.601252,345.725985 C540.570566,342.041436 541.22597,342.913279 543.228465,343.371363 C544.025208,343.553623 545.692585,343.736429 548.230595,343.91978 C545.537354,339.474885 544.565702,335.090391 545.31564,330.766301 C546.440546,324.280164 549.593201,339.235052 552.131798,340.36866 C554.670395,341.502268 557.092748,344.638211 556.635592,336.521747 C556.178436,328.405283 564.313935,341.38022 557.092748,346.47746 C549.871561,351.5747 563.512218,355.153533 563.643579,346.47746 C563.774939,337.801387 576.366796,349.813796 569.348906,355.757911 C564.670312,359.720655 561.805746,361.702026 560.755208,361.702026 C563.489803,366.979407 567.502211,365.992007 572.792431,358.739828 C580.727762,347.86156 576.30268,367.679718 571.036786,368.39655 C567.52619,368.874439 564.624266,369.113383 562.331015,369.113383 Z",
    id: "Path-94-Copy",
    stroke: "none",
    fill: "url(#linearGradient-24)",
    fillRule: "evenodd",
    transform: "translate(558.461976, 353.722197) scale(-1, 1) translate(-558.461976, -353.722197) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.911639,370.226987 C551.864408,375.158791 550.848664,386.841867 551.864408,405.276214",
    id: "Path-95",
    stroke: "#1937A7",
    strokeWidth: 2.29801325,
    fill: "none"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-39",
    stroke: "none",
    fill: "url(#linearGradient-25)",
    fillRule: "evenodd",
    points: "15.6202792 99.3860387 133.888108 99.3860387 133.888108 150.665747 15.6202792 150.665747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.14900662,167.851976 L83.6467949,167.851976 C84.2813737,167.851976 84.7958015,168.366404 84.7958015,169.000983 L84.7958015,171.120127 C84.7958015,171.754706 84.2813737,172.269134 83.6467949,172.269134 L1.14900662,172.269134 C0.514427787,172.269134 3.18633796e-15,171.754706 3.10862447e-15,171.120127 L-2.22044605e-16,169.000983 C-2.99758099e-16,168.366404 0.514427787,167.851976 1.14900662,167.851976 Z",
    id: "Rectangle-41",
    stroke: "none",
    fill: "url(#linearGradient-26)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.38047508,178.89487 L59.1006418,178.89487 C59.7352206,178.89487 60.2496484,179.409297 60.2496484,180.043876 L60.2496484,182.16302 C60.2496484,182.797599 59.7352206,183.312027 59.1006418,183.312027 L3.38047508,183.312027 C2.74589625,183.312027 2.23146846,182.797599 2.23146846,182.16302 L2.23146846,180.043876 C2.23146846,179.409297 2.74589625,178.89487 3.38047508,178.89487 Z",
    id: "Rectangle-41-Copy",
    stroke: "none",
    fill: "url(#linearGradient-26)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.38047508,189.937763 L50.174768,189.937763 C50.8093468,189.937763 51.3237746,190.452191 51.3237746,191.086769 L51.3237746,193.205913 C51.3237746,193.840492 50.8093468,194.35492 50.174768,194.35492 L3.38047508,194.35492 C2.74589625,194.35492 2.23146846,193.840492 2.23146846,193.205913 L2.23146846,191.086769 C2.23146846,190.452191 2.74589625,189.937763 3.38047508,189.937763 Z",
    id: "Rectangle-41-Copy-2",
    stroke: "none",
    fill: "url(#linearGradient-26)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.38047508,200.980656 L50.174768,200.980656 C50.8093468,200.980656 51.3237746,201.495084 51.3237746,202.129663 L51.3237746,204.248807 C51.3237746,204.883386 50.8093468,205.397813 50.174768,205.397813 L3.38047508,205.397813 C2.74589625,205.397813 2.23146846,204.883386 2.23146846,204.248807 L2.23146846,202.129663 C2.23146846,201.495084 2.74589625,200.980656 3.38047508,200.980656 Z",
    id: "Rectangle-41-Copy-3",
    stroke: "none",
    fill: "url(#linearGradient-26)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.581964,308.091057 L360.802306,308.091057 C362.387545,322.752884 359.338561,334.991033 351.655353,344.805503 C343.972145,354.619973 338.378029,371.062412 334.873005,394.132819 L322.870861,394.132819 C323.856123,362.752476 324.50863,346.686171 324.828381,345.933904 C325.148132,345.181637 329.065993,332.567354 336.581964,308.091057 Z",
    id: "Path-27",
    stroke: "none",
    fill: "#D8D8D8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.933775,308.091057 C310.427268,329.247971 314.360928,341.168234 319.734756,343.851845 C325.108583,346.535457 328.533793,348.953165 330.010386,351.104972 L339.592133,392.301578 C340.309392,394.655253 342.781563,395.832091 347.008646,395.832091 C351.235729,395.832091 352.975889,392.592533 352.229126,386.113417 L352.229126,348.45256 C342.535028,328.903881 337.498306,317.686371 337.118958,314.800032 C336.73961,311.913692 336.73961,309.935394 337.118958,308.865137 L307.933775,308.091057 Z",
    id: "Path-26",
    stroke: "none",
    fill: "#F7F5F6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-25",
    stroke: "none",
    fill: "url(#linearGradient-27)",
    fillRule: "evenodd",
    points: "190.735099 195.746731 258.395316 83.9203252 360.866257 83.9203252 210.96579 195.746731"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-42",
    stroke: "none",
    fill: "#C6EFF7",
    fillRule: "evenodd",
    opacity: 0.490206069,
    points: "238.993377 83.9203252 417.089404 83.9203252 417.089404 204.627642 238.993377 204.627642"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-96",
    stroke: "none",
    fill: "url(#linearGradient-28)",
    fillRule: "evenodd",
    points: "240.142384 173.788264 285.087925 137.95122 296.439209 143.368169 308.476085 137.95122 328.491 147.479851"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.142384,145.401732 C245.904473,139.567651 250.955548,137.622957 255.295609,139.567651 C259.63567,141.512345 261.8057,143.457038 261.8057,145.401732 L276.306764,139.567651 L292.112693,142.120061 L340.794619,106.912195 L340.794619,145.401732 L240.142384,175.024743 L240.142384,145.401732 Z",
    id: "Path-97",
    stroke: "none",
    fill: "url(#linearGradient-28)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.142384,179.250082 L339.090697,134.254324 L370.419532,146.335856 C377.537622,141.169411 382.937572,137.864211 386.619382,136.420256 C390.301193,134.976301 392.142098,136.701098 392.142098,141.594647 C397.436288,135.566229 400.897635,132.439765 402.526139,132.215256 C404.968896,131.878492 403.951684,136.270712 404.968896,138.228026 C405.986108,140.18534 413.227542,128.080201 418.636134,126.342294 C424.044725,124.604387 431.750314,124.17884 435.596906,132.215256 C438.161301,137.572867 442.053378,144.26041 447.273137,152.277887 C425.706928,142.056908 413.748638,140.076231 411.398267,146.335856 C409.047896,152.595481 400.788268,154.576157 386.619382,152.277887 L240.142384,189.92405 L240.142384,179.250082 Z",
    id: "Path-98",
    stroke: "none",
    fill: "url(#linearGradient-28)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-99",
    stroke: "none",
    fill: "url(#linearGradient-28)",
    fillRule: "evenodd",
    points: "284.953642 188.554574 346.999702 147.600422 372.650312 157.557995 384.218808 151.252318 399.087259 162.430682 422.674731 142.549593 441.728098 157.557995 405.903076 181.193148 384.218808 162.430682 375.625068 188.554574"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.213118,135.832309 C378.115355,115.994624 361.660684,107.244093 332.849105,109.580715 C304.037526,111.917337 292.327267,124.559827 297.718326,147.508186 L382.213118,135.832309 Z",
    id: "Path-100",
    stroke: "none",
    fill: "url(#linearGradient-28)",
    fillRule: "evenodd"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup25);
export default __webpack_public_path__ + "static/media/Group 25.9e92f0fb94248645797c84b91706817d.svg";
export { ForwardRef as ReactComponent };